import requestReducer from '../requestReducer';
import Prepayment from '../../models/Prepayment';
import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'


export interface PrepaymentDiscountsState extends PaginatedApiState {
  prepaymentDiscounts?: Prepayment[]
}

const PrepaymentDiscounts = (state: PrepaymentDiscountsState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<PrepaymentDiscountsState>('PREPAYMENT_DISCOUNTS')(state, action)
  }
}

export default PrepaymentDiscounts
